import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import IconCheck from 'design-system/icons/IconCheck';
import { IconBell, IconShieldDone } from 'design-system/icons';
import useColors from 'hooks/useColors';
import { Tier } from '../../entities';
import { NewFreeTrialStepView } from './NewFreeTrialStepView';
const tierToText = {
    [Tier.free]: 'a member',
    [Tier.plus]: 'a Plus member',
    [Tier.pro]: 'a Pro member',
    [Tier.ultimate]: 'an Ultimate member',
};
const FreeTrialList = ({ style, white, selectedTier, eligibleFreeTrialDays, longLastAbsLine = false, isMicroModal, }) => {
    const colors = useColors();
    return (<View style={[!white && styles.container, style]}>
      <NewFreeTrialStepView first white={white} title="Today" icon={<IconCheck width={rem(18)} thick color={white
                ? colors.gradients.darkPurple.colors[0]
                : colors.elements.white}/>} description="Get full access to the most popular tools for free" isMicroModal={isMicroModal}/>
      <NewFreeTrialStepView white={white} icon={<IconBell color={white ? colors.elements.white : colors.elements.brand}/>} title={`Day ${eligibleFreeTrialDays - 2}`} description="Get reminded that your free trial is about to end" isMicroModal={isMicroModal}/>
      <NewFreeTrialStepView last white={white} longAbsLine={longLastAbsLine} icon={<IconShieldDone color={white ? colors.elements.white : colors.elements.brand}/>} title={`Day ${eligibleFreeTrialDays}`} description={<Text TextThin-14 {...(white ? { White: true } : { Secondary: true })}>
            {`You become ${tierToText[selectedTier]} & are charged – `}
            <Text Text-14 {...(white ? { White: true } : { Secondary: true })}>
              cancel anytime before
            </Text>
          </Text>} isMicroModal={isMicroModal}/>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        padding: rem(24),
    },
});
export default FreeTrialList;
